interface LsInfo {
}

interface ClientProps {
  [key: string]: boolean|number|string|null|ClientProps,
}

interface ClientInfoProps {
  windowProps: ClientProps,
  lsInfo: LsInfo,
}

interface KeyDef {
  [key: string]: boolean|KeyDef,
}

const windowKeys: KeyDef = {
  devicePixelRatio: true,
  frameElement: {
    src: true,
  },
  innerHeight: true,
  innerWidth: true,
  isSecureContext: true,
  // location: {
  //   hash: true,
  //   host: true,
  //   hostname: true,
  //   href: true,
  //   origin: true,
  //   pathname: true,
  //   port: true,
  //   protocol: true,
  //   search: true,
  // },
  locationbar: {
    visible: true,
  },
  menubar: {
    visible: true,
  },
  navigator: {
    appCodeName: true,
    appName: true,
    appVersion: true,
    connection: {
      downlink: true,
      effectiveType: true,
      rtt: true,
      saveData: true,
    },
    cookieEnabled: true,
    deviceMemory: true,
    doNotTrack: true,
    hardwareConcurrency: true,
    language: true,
    languages: true,
    maxTouchPoints: true,
    platform: true,
    product: true,
    productSub: true,
    userAgent: true,
    vendor: true,
    vendorSub: true,
    webdriver: true,
  },
  orientation: true,
  origin: true,
  outerHeight: true,
  outerWidth: true,
  performance: {
    eventCounts: {
      size: true,
    },
    memory: {
      jsHeapSizeLimit: true,
      totalJSHeapSize: true,
      usedJSHeapSize: true,
    },
    navigation: {
      redirectCount: true,
      type: true,
    },
    timeOrigin: true,
  },
  personalbar: {
    visible: true,
  },
  screen: {
    availHeight: true,
    availLeft: true,
    availTop: true,
    availWidth: true,
    colorDepth: true,
    height: true,
    orientation: {
      angle: true,
      type: true,
    },
    pixelDepth: true,
    width: true,
  },
  scrollbars: {
    visible: true,
  },
  statusbar: {
    visible: true,
  },
  toolbar: {
    visible: true,
  },
}
export class ClientInfoUtil {

  private static setProperties = (
    srcObj: any,
    clientProps: ClientProps,
    keyDef: KeyDef,
  ) => {

    const srcObjType = typeof srcObj;

    if (
      srcObj === null ||
      srcObjType !== `object`
    ) {

      return;
    }

    const keys = Object.keys(keyDef);

    for (const key of keys) {

      const keyVal = keyDef[key];

      if (typeof keyVal === `boolean`) {

        // 値の場合
        const clientProp = srcObj[key];

        if (clientProp === undefined) {
          clientProps[key] = null;
        } else {

          const typeofClientProp = typeof clientProp;

          if (
            typeofClientProp === `object` ||
            typeofClientProp === `function` ||
            typeofClientProp === `undefined` ||
            typeofClientProp === `bigint` ||
            typeofClientProp === `symbol`
          ) {
            clientProps[key] = `${clientProp}`;
          } else {
            clientProps[key] = clientProp;
          }
        }
      } else {

        // objectの場合

        // 値がnullの場合はnullをセットする
        if (srcObj[key] === null) {

          clientProps[key] = null;

        } else {

          clientProps[key] = {}

          // 再帰的にpropsをセットする
          ClientInfoUtil.setProperties(
            srcObj[key],
            clientProps[key] as ClientProps,
            keyVal,
          );
        }
      }
    }
  }

  public static getProperties = (): ClientInfoProps => {

    const clientInfoProps: ClientInfoProps = {
      windowProps: {},
      lsInfo: {},
    };

    try {
      ClientInfoUtil.setProperties(
        window,
        clientInfoProps.windowProps,
        windowKeys,
      );
    } catch (error) {
      console.error(error);
    }

    return clientInfoProps;
  }
}
